import React, { useEffect, useState } from 'react'
import {
  ExampleTabMenu,
  Hero,
  HowItWorks,
  HowItWorksMobile,
} from './components'
import { Button } from 'cwp-components/forms'
import { CTA_WhoWeAre } from 'cwp-components/cta'
import { Feedback } from 'cwp-components/popups'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'
import './index.scss'
import { useLawFinder } from 'common/hooks/useLawFinder'
import Checks from './components/Checks'
import FeaturedArticles from './components/FeaturedArticles'
import { LUGroup } from './components/LUGroup'
import LawyerTypes from './components/LawyerTypes'
import Documents from './components/Documents'

const HomePage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { featuredHome, loadFeaturedHome } = useArticleTemplate()
  const { exampleContents, examplesContentsLoading, getExampleContents } =
    useLawFinder()

  useEffect(getExampleContents, [getExampleContents])
  useEffect(loadFeaturedHome, [loadFeaturedHome])

  return (
    <>
      <section id='home'>
        <div className='sm:contents hidden'>
          <Button
            className='fixed left-[10px] hover:left-[20px] top-[60vh] bg-white  rounded-r-lg shadow-md transform -rotate-90 origin-left z-[1000] p-4 pt-2'
            onClick={() => setIsModalOpen(true)}
          >
            <span className='text-[#37A2BA] font-semibold '>
              Give us your feedback
            </span>
          </Button>
        </div>

        <div className='relative flex flex-col gap-[25px] items-center md:flex-row'>
          <div className='w-full relative'>
            <Hero />
          </div>
          <div className='hidden sm:contents'>
            <ExampleTabMenu
              className='static sm:absolute sm:top-8 sm:right-0 z-50'
              tabs={exampleContents}
              isLoading={examplesContentsLoading}
            />
          </div>
        </div>
        <Checks />
        <div className='relative sm:hidden min-h-[40px]'>
          <HowItWorksMobile />
        </div>
        <div className='relative sm:hidden min-h-[40px]'>
          <ExampleTabMenu
            tabs={exampleContents}
            isLoading={examplesContentsLoading}
          />
        </div>
        <div className='hidden sm:contents'>
          <HowItWorks />
        </div>
        <Button
          className='mt-6 mx-auto block bg-white rounded-lg shadow-md sm:hidden'
          onClick={() => setIsModalOpen(true)}
        >
          <span className='text-[#37A2BA] font-semibold text-sm'>
            Give us your feedback
          </span>
        </Button>

        <LawyerTypes />
        <FeaturedArticles featuredHome={featuredHome} />

        <div className='relative'>
          <div className='absolute inset-0 bg-transparent'>
            <div
              className='absolute top-[100px] left-0 w-full bg-[#D0E2FA]'
              style={{ height: 'calc(100% - 100px)' }}
            />
          </div>
          <div className='relative'>
            <Documents />
            <LUGroup />
            <CTA_WhoWeAre />
          </div>
        </div>
      </section>

      <Feedback open={isModalOpen} closeModal={() => setIsModalOpen(false)} />
    </>
  )
}

export default HomePage
